module.exports = __webpack_public_path__ + "img/wdsy.225c2b3f.png";